import React, { useCallback, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Close, ReceiptLongOutlined, VpnKey } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useAppDispatch } from "../../redux/slice/redux-hooks";
import { Box, Grid, IconButton, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { priceFormatter } from "../../utils/Utility";
import { tokens } from "../../theme";
import { useNavigation } from "../../hooks/useNavigation";
import { useModalStyles } from "./useModalStyles";

interface CreditMemoPopupProps {
    open: boolean;
    onClose: () => void;
    recordCreditMemo: any
}

const CreditMemoTable: React.FC<CreditMemoPopupProps> = ({
    open,
    onClose,
    recordCreditMemo
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const colors = tokens(theme.palette.mode);
    const {
        tokens: modalTokens,
        paperSx,
        headerSx,
        iconBoxSx,
        closeIconSx,
        bodySx,
        footerSx,
        cancelBtnSx,
    } = useModalStyles();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const { navigate } = useNavigation();

    const handleClose = () => {
        onClose();
        // defaultValues();
    };

    return (
        <>
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                onClick={(event) => event.stopPropagation()}
                maxWidth="lg"  // Make the dialog wider (large size)
                fullWidth
                fullScreen={isMobile}
                PaperProps={{ sx: paperSx(isMobile) }}
            >
                <Box sx={headerSx}>
                    <Box sx={iconBoxSx(modalTokens.accent)}>
                        <ReceiptLongOutlined sx={{ fontSize: "1.1rem", color: modalTokens.accent }} />
                    </Box>
                    <Box sx={{ flex: 1, pr: 4 }}>
                        <Typography fontWeight={700} sx={{ fontSize: "1rem", color: modalTokens.textPrimary, lineHeight: 1.3 }}>
                            Credit Memo History
                        </Typography>
                        <Typography sx={{ fontSize: "0.75rem", color: modalTokens.textSecondary, mt: 0.15 }}>
                            View all recorded credit memo entries for this invoice.
                        </Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small" sx={closeIconSx}>
                        <Close sx={{ fontSize: "1rem" }} />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        ...bodySx,
                        bgcolor: colors.grey[900]
                    }}
                >
                    <Box>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <List>
                                    <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <ListItemText sx={{
                                            width: '10%', color: theme.palette.mode === "dark"
                                                ? colors.info[300]
                                                : colors.grey[500]
                                        }}>
                                            <b>Date Of Credit</b>
                                        </ListItemText>
                                        <ListItemText sx={{
                                            width: '10%', color: theme.palette.mode === "dark"
                                                ? colors.info[300]
                                                : colors.grey[500]
                                        }}>
                                            <b>Credit Amount</b>
                                        </ListItemText>
                                        <ListItemText sx={{
                                            width: '20%', color: theme.palette.mode === "dark"
                                                ? colors.info[300]
                                                : colors.grey[500]
                                        }}>
                                            <b>User</b>
                                        </ListItemText>
                                        <ListItemText sx={{
                                            width: '20%', color: theme.palette.mode === "dark"
                                                ? colors.info[300]
                                                : colors.grey[500]
                                        }}>
                                            <b>Comments</b>
                                        </ListItemText>
                                    </ListItem>

                                    {recordCreditMemo?.creditMemoDTOList?.length > 0 && (
                                        <>
                                            {recordCreditMemo?.creditMemoDTOList?.map((row: any) => (
                                                <ListItem key={row?.productReturnId} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <ListItemText sx={{ width: '10%' }}>
                                                        {row.dateOfCredit}
                                                    </ListItemText>
                                                    <ListItemText sx={{ width: '10%' }}>
                                                        {priceFormatter(row.creditAmount)}
                                                    </ListItemText>
                                                    <ListItemText sx={{ width: '20%' }}>
                                                        {row.auditUserName}
                                                    </ListItemText>
                                                    <ListItemText sx={{ width: '20%' }}>
                                                        {row.comments}
                                                    </ListItemText>
                                                </ListItem>
                                            ))}
                                        </>
                                    )}
                                </List>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Box sx={{ ...footerSx, bgcolor: colors.grey[900] }}>
                    <Grid container justifyContent="flex-end" >
                        <Grid item xs={12} sm="auto">
                            <Box
                                component="button"
                                type="button"
                                onClick={() => handleClose()}
                                sx={{
                                    ...cancelBtnSx,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 0.8,
                                    px: 3,
                                    py: 1.2,
                                    border: "1px solid",
                                    cursor: "pointer",
                                    order: { xs: 2, sm: 1 },
                                    width: "100%",
                                }}
                            >
                                Cancel
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
        </>
    );
};

export default CreditMemoTable;
